import React, { useState } from "react";
// import React from "react";
import "../assets/css/formSheet.css";
import { useLocation } from "react-router-dom";
import DATA from "../components/Data.js";
import Payment from "../components/Payment.js";
import NoPage from "./NoPage.js";
import FinancialModal from "../components/FinancialModal";
import SubHero from "../components/SubHero.js";

const FormSheet = () => {
  //get current location and get the current course
  const location = useLocation();
  const lastPathSplit = location.pathname.split("/");
  const lastPath = lastPathSplit[lastPathSplit.length - 1];
  const findItem = DATA.find((item) => item.slot === lastPath.slice(0, -3));

  //state that shows the finiancial aid modal
  const [active, setActive] = useState(false);
  return (
    <>
      <SubHero name={`enroll/${findItem.slot}%7D`} />
      <div className="formSheet-container">
        {findItem ? (
          <div className="formSheet-content">
            <div className="formSheet-title">
              <h2>Complete Your Enrollment And Start Learning </h2>
              <div className="course">
                <img src={findItem.courseImage} alt={findItem.courseName} />
                <div className="course-detail">
                  <p className="course-detail-text">
                    Course Name: <span>{findItem.courseName}.</span>
                  </p>
                  <p className="course-detail-text">
                    Course Description:{" "}
                    <span>{findItem.courseDescription}.</span>
                  </p>
                  <p className="course-detail-text">
                    Course Price: <span>N{findItem.coursePrice}</span>
                  </p>
                  <div className="financial-link">
                    <span onClick={() => setActive(true)}>
                      Financial aid available
                    </span>
                  </div>
                  {active ? (
                    <FinancialModal
                      setActive={setActive}
                      courseName={findItem.courseName}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <Payment />
          </div>
        ) : (
          <NoPage />
        )}
      </div>
    </>
  );
};

export default FormSheet;
